import _asyncToGenerator from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import "core-js/modules/es.array.sort.js";
import _regeneratorRuntime from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a, _b, _c, _d, _e, _f;
import { Mesh } from 'three';
import { $setActive, $variantSet, Material } from './material.js';
import { Node, PrimitiveNode } from './nodes/primitive-node.js';
import { $correlatedObjects } from './three-dom-element.js';
export var $materials = Symbol('materials');
var $hierarchy = Symbol('hierarchy');
var $roots = Symbol('roots');
export var $primitivesList = Symbol('primitives');
export var $loadVariant = Symbol('loadVariant');
export var $prepareVariantsForExport = Symbol('prepareVariantsForExport');
export var $switchVariant = Symbol('switchVariant');
export var $materialFromPoint = Symbol('materialFromPoint');
export var $nodeFromPoint = Symbol('nodeFromPoint');
export var $nodeFromIndex = Symbol('nodeFromIndex');
export var $variantData = Symbol('variantData');
export var $availableVariants = Symbol('availableVariants');
var $modelOnUpdate = Symbol('modelOnUpdate');
var $cloneMaterial = Symbol('cloneMaterial');
// Holds onto temporary scene context information needed to perform lazy loading
// of a resource.
export var LazyLoader = /*#__PURE__*/_createClass(function LazyLoader(gltf, gltfElementMap, mapKey, doLazyLoad) {
  _classCallCheck(this, LazyLoader);
  this.gltf = gltf;
  this.gltfElementMap = gltfElementMap;
  this.mapKey = mapKey;
  this.doLazyLoad = doLazyLoad;
});
/**
 * A Model facades the top-level GLTF object returned by Three.js' GLTFLoader.
 * Currently, the model only bothers itself with the materials in the Three.js
 * scene graph.
 */
export var Model = /*#__PURE__*/function (_ref) {
  function Model(correlatedSceneGraph) {
    var _this = this;
    var onUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    _classCallCheck(this, Model);
    this[_a] = new Array();
    this[_b] = new Array();
    this[_c] = new Array();
    this[_d] = new Array();
    this[_e] = function () {};
    this[_f] = new Map();
    this[$modelOnUpdate] = onUpdate;
    var gltf = correlatedSceneGraph.gltf,
      threeGLTF = correlatedSceneGraph.threeGLTF,
      gltfElementMap = correlatedSceneGraph.gltfElementMap;
    var _iterator = _createForOfIteratorHelper(gltf.materials.entries()),
      _step;
    try {
      var _loop = function _loop() {
        var _step$value = _slicedToArray(_step.value, 2),
          i = _step$value[0],
          material = _step$value[1];
        var correlatedMaterial = gltfElementMap.get(material);
        if (correlatedMaterial != null) {
          _this[$materials].push(new Material(onUpdate, i, true, _this[$variantData], correlatedMaterial, material.name));
        } else {
          var elementArray = gltf['materials'] || [];
          var gltfMaterialDef = elementArray[i];
          // Loads the three.js material.
          var capturedMatIndex = i;
          var materialLoadCallback = /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var threeMaterial, threeMaterialSet;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return threeGLTF.parser.getDependency('material', capturedMatIndex);
                  case 2:
                    threeMaterial = _context.sent;
                    // Adds correlation, maps the variant gltf-def to the
                    // three material set containing the variant material.
                    threeMaterialSet = new Set();
                    gltfElementMap.set(gltfMaterialDef, threeMaterialSet);
                    threeMaterialSet.add(threeMaterial);
                    return _context.abrupt("return", {
                      set: threeMaterialSet,
                      material: threeMaterial
                    });
                  case 7:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function materialLoadCallback() {
              return _ref2.apply(this, arguments);
            };
          }();
          // Configures the material for lazy loading.
          _this[$materials].push(new Material(onUpdate, i, false, _this[$variantData], correlatedMaterial, material.name, new LazyLoader(gltf, gltfElementMap, gltfMaterialDef, materialLoadCallback)));
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
      // Creates a hierarchy of Nodes. Allows not just for switching which
      // material is applied to a mesh but also exposes a way to provide API
      // for switching materials and general assignment/modification.
      // Prepares for scene iteration.
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var parentMap = new Map();
    var nodeStack = new Array();
    var _iterator2 = _createForOfIteratorHelper(threeGLTF.scene.children),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _object = _step2.value;
        nodeStack.push(_object);
      }
      // Walks the hierarchy and creates a node tree.
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    while (nodeStack.length > 0) {
      var object = nodeStack.pop();
      var node = null;
      if (object instanceof Mesh) {
        node = new PrimitiveNode(object, this.materials, this[$variantData], correlatedSceneGraph);
        this[$primitivesList].push(node);
      } else {
        node = new Node(object.name);
      }
      var parent = parentMap.get(object);
      if (parent != null) {
        parent.children.push(node);
      } else {
        this[$roots].push(node);
      }
      this[$hierarchy].push(node);
      var _iterator3 = _createForOfIteratorHelper(object.children),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          nodeStack.push(child);
          parentMap.set(object, node);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }
  /**
   * Materials are listed in the order of the GLTF materials array, plus a
   * default material at the end if one is used.
   *
   * TODO(#1003): How do we handle non-active scenes?
   */
  _createClass(Model, [{
    key: "materials",
    get: function get() {
      return this[$materials];
    }
  }, {
    key: _ref,
    value: function value() {
      var variants = Array.from(this[$variantData].values());
      variants.sort(function (a, b) {
        return a.index - b.index;
      });
      return variants.map(function (data) {
        return data.name;
      });
    }
  }, {
    key: "getMaterialByName",
    value: function getMaterialByName(name) {
      var matches = this[$materials].filter(function (material) {
        return material.name === name;
      });
      if (matches.length > 0) {
        return matches[0];
      }
      return null;
    }
  }, {
    key: $nodeFromIndex,
    value: function value(mesh, primitive) {
      var found = this[$hierarchy].find(function (node) {
        if (node instanceof PrimitiveNode) {
          var _node$mesh$userData$a = node.mesh.userData.associations,
            meshes = _node$mesh$userData$a.meshes,
            primitives = _node$mesh$userData$a.primitives;
          if (meshes == mesh && primitives == primitive) {
            return true;
          }
        }
        return false;
      });
      return found == null ? null : found;
    }
  }, {
    key: $nodeFromPoint,
    value: function value(hit) {
      return this[$hierarchy].find(function (node) {
        if (node instanceof PrimitiveNode) {
          var primitive = node;
          if (primitive.mesh === hit.object) {
            return true;
          }
        }
        return false;
      });
    }
    /**
     * Intersects a ray with the Model and returns the first material whose
     * object was intersected.
     */
  }, {
    key: $materialFromPoint,
    value: function value(hit) {
      return this[$nodeFromPoint](hit).getActiveMaterial();
    }
    /**
     * Switches model variant to the variant name provided, or switches to
     * default/initial materials if 'null' is provided.
     */
  }, {
    key: $switchVariant,
    value: function () {
      var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(variantName) {
        var _iterator4, _step4, primitive, _iterator5, _step5, material, _iterator6, _step6, _primitive;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(this[$primitivesList]);
              _context2.prev = 1;
              _iterator4.s();
            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context2.next = 9;
                break;
              }
              primitive = _step4.value;
              _context2.next = 7;
              return primitive.enableVariant(variantName);
            case 7:
              _context2.next = 3;
              break;
            case 9:
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);
              _iterator4.e(_context2.t0);
            case 14:
              _context2.prev = 14;
              _iterator4.f();
              return _context2.finish(14);
            case 17:
              _iterator5 = _createForOfIteratorHelper(this.materials);
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  material = _step5.value;
                  material[$setActive](false);
                }
                // Marks the materials that are now in use after the variant switch.
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              _iterator6 = _createForOfIteratorHelper(this[$primitivesList]);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  _primitive = _step6.value;
                  this.materials[_primitive.getActiveMaterial().index][$setActive](true);
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 11, 14, 17]]);
      }));
      function value(_x) {
        return _value.apply(this, arguments);
      }
      return value;
    }()
  }, {
    key: $prepareVariantsForExport,
    value: function () {
      var _value2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var promises, _iterator7, _step7, primitive;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              promises = new Array();
              _iterator7 = _createForOfIteratorHelper(this[$primitivesList]);
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  primitive = _step7.value;
                  promises.push(primitive.instantiateVariants());
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              _context3.next = 5;
              return Promise.all(promises);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function value() {
        return _value2.apply(this, arguments);
      }
      return value;
    }()
  }, {
    key: $cloneMaterial,
    value: function value(index, newMaterialName) {
      var material = this.materials[index];
      if (!material.isLoaded) {
        console.error("Cloning an unloaded material,\n           call 'material.ensureLoaded() before cloning the material.");
      }
      var threeMaterialSet = material[$correlatedObjects];
      var clonedSet = new Set();
      var _iterator8 = _createForOfIteratorHelper(threeMaterialSet.entries()),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _step8$value = _slicedToArray(_step8.value, 2),
            i = _step8$value[0],
            threeMaterial = _step8$value[1];
          var clone = threeMaterial.clone();
          clone.name = newMaterialName + (threeMaterialSet.size > 1 ? '_inst' + i : '');
          clonedSet.add(clone);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      var clonedMaterial = new Material(this[$modelOnUpdate], this[$materials].length, false,
      // Cloned as inactive.
      this[$variantData], clonedSet, newMaterialName);
      this[$materials].push(clonedMaterial);
      return clonedMaterial;
    }
  }, {
    key: "createMaterialInstanceForVariant",
    value: function createMaterialInstanceForVariant(originalMaterialIndex, newMaterialName, variantName) {
      var activateVariant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var variantMaterialInstance = null;
      var _iterator9 = _createForOfIteratorHelper(this[$primitivesList]),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _primitive2 = _step9.value;
          var variantData = this[$variantData].get(variantName);
          // Skips the primitive if the variant already exists.
          if (variantData != null && _primitive2.variantInfo.has(variantData.index)) {
            continue;
          }
          // Skips the primitive if the source/original material does not exist.
          if (_primitive2.getMaterial(originalMaterialIndex) == null) {
            continue;
          }
          if (!this.hasVariant(variantName)) {
            this.createVariant(variantName);
          }
          if (variantMaterialInstance == null) {
            variantMaterialInstance = this[$cloneMaterial](originalMaterialIndex, newMaterialName);
          }
          _primitive2.addVariant(variantMaterialInstance, variantName);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      if (activateVariant && variantMaterialInstance != null) {
        variantMaterialInstance[$setActive](true);
        this.materials[originalMaterialIndex][$setActive](false);
        var _iterator10 = _createForOfIteratorHelper(this[$primitivesList]),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var primitive = _step10.value;
            primitive.enableVariant(variantName);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
      return variantMaterialInstance;
    }
  }, {
    key: "createVariant",
    value: function createVariant(variantName) {
      if (!this[$variantData].has(variantName)) {
        // Adds the name if it's not already in the list.
        this[$variantData].set(variantName, {
          name: variantName,
          index: this[$variantData].size
        });
      } else {
        console.warn("Variant '".concat(variantName, "'' already exists"));
      }
    }
  }, {
    key: "hasVariant",
    value: function hasVariant(variantName) {
      return this[$variantData].has(variantName);
    }
  }, {
    key: "setMaterialToVariant",
    value: function setMaterialToVariant(materialIndex, targetVariantName) {
      if (this[$availableVariants]().find(function (name) {
        return name === targetVariantName;
      }) == null) {
        console.warn("Can't add material to '".concat(targetVariantName, "', the variant does not exist.'"));
        return;
      }
      if (materialIndex < 0 || materialIndex >= this.materials.length) {
        console.error("setMaterialToVariant(): materialIndex is out of bounds.");
        return;
      }
      var _iterator11 = _createForOfIteratorHelper(this[$primitivesList]),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var primitive = _step11.value;
          var material = primitive.getMaterial(materialIndex);
          // Ensures the material exists on the primitive before setting it to a
          // variant.
          if (material != null) {
            primitive.addVariant(material, targetVariantName);
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  }, {
    key: "updateVariantName",
    value: function updateVariantName(currentName, newName) {
      var variantData = this[$variantData].get(currentName);
      if (variantData == null) {
        return;
      }
      variantData.name = newName;
      this[$variantData].set(newName, variantData);
      this[$variantData].delete(currentName);
    }
  }, {
    key: "deleteVariant",
    value: function deleteVariant(variantName) {
      var variant = this[$variantData].get(variantName);
      if (variant == null) {
        return;
      }
      var _iterator12 = _createForOfIteratorHelper(this.materials),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var material = _step12.value;
          if (material.hasVariant(variantName)) {
            material[$variantSet].delete(variant.index);
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      var _iterator13 = _createForOfIteratorHelper(this[$primitivesList]),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var primitive = _step13.value;
          primitive.deleteVariant(variant.index);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      this[$variantData].delete(variantName);
    }
  }]);
  return Model;
}((_a = $materials, _b = $hierarchy, _c = $roots, _d = $primitivesList, _e = $modelOnUpdate, _f = $variantData, $availableVariants));